<template>
  <div class="report-container">
    <nav class="add-navigation">
      <div class="btns">
        <div class="button">
          <button class="PrimaryButton ff-p fw-5 fs-15" @click="search">
            Sent
          </button>
        </div>
      </div>
      <div class="right-wrapper">
        <h4 class="header-main">Report Filter</h4>
        <div class="inputs-box">
          <div class="first-line">
            <div class="search-boxes">
              <div class="element equal-field">
                <div class="header">
                  <span class="filter_by">DNIS Prefix</span>
                </div>
                <div class="primary-input-container input">
                  <input
                    type="text"
                    placeholder
                    v-model="selected.dnis_prefix"
                  />
                </div>
              </div>
              <div class="element equal-field">
                <div class="header">
                  <span class="filter_by">ANI</span>
                </div>
                <div class="primary-input-container input">
                  <input type="text" placeholder v-model="selected.ani" />
                </div>
              </div>
              <div class="element equal-field">
                <div class="header">
                  <span class="filter_by">Step</span>
                </div>
                <div
                  id="smsc-connecion-select"
                  class="primary-input-container search-input equal-field"
                >
                  <primary-select v-model="selected.step">
                    <option
                      v-for="item in steps"
                      :key="item.value"
                      :value="item.value"
                    >
                      {{ item.name }}
                    </option>
                  </primary-select>
                </div>
              </div>
            </div>
            <div class="btns export-button" @click="exportData">
              <primary-button>Export</primary-button>
            </div>
          </div>
          <div class="second-line">
            <div class="selects-wrapper">
              <div class="top-said">
                <div id="ss" class="inputs"></div>
              </div>
              <div class="inputs date-inputs">
                <div class="equal-field date-picker">
                  <date-time-picker
                    header="START DATE"
                    header_font_size="12"
                    header_font_weight="700"
                    :initial_time="new Date(startTime)"
                    @getTime="getStartTime"
                  ></date-time-picker>
                </div>
                <div class="equal-field date-picker">
                  <date-time-picker
                    header="END DATE"
                    header_font_size="12"
                    header_font_weight="700"
                    :initial_time="new Date(endTime)"
                    @getTime="getEndTime"
                  ></date-time-picker>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <loader :loading="loading" v-if="loading" />
    <not-found v-else-if="!reports.length || !showData" />
    <template v-else-if="!loading">
      <div
        class="table_div"
        style="width: 100%; overflow-x: auto; overflow-y: hidden"
      >
        <table class="Invoice_table" ref="table">
          <thead>
            <tr class="Invoice_table_header">
              <th class="date">Date</th>
              <th>Total</th>
              <th>Success</th>
              <th>Cost</th>
            </tr>
          </thead>
          <tbody>
            <tr class="line" v-for="(report, k) in reports" :key="k">
              <th class="date">{{ report.sms_time }}</th>
              <th>{{ report.sent }}</th>
              <th>{{ report.delivered }}</th>
              <th>{{ report.tx_cost }}</th>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="per-page-box">
        <div class="header">
          <span class="filter_by per_page">Show Per Page</span>
        </div>
        <div class="item">
          <div
            class="primary-input-container choose-type perPage equal-field box"
            type="text"
            placeholder="Select"
          >
            <div data-v-433119f5 class="primary-select-wrapper">
              <select data-v-433119f5 v-model="per_page" :is-cross="false">
                <option
                  v-for="page in pages"
                  :key="page.name"
                  data-v-d95b1fee
                  :value="page.value"
                >
                  {{ page.value }}
                </option>
              </select>
              <img src="/img/Down.08f08d5c.svg" alt class="icon-down" />
            </div>
          </div>
        </div>
      </div>
      <div class="buttons-wrapper">
        <pagination-component
          @change-page="changePage($event)"
          :page="Page"
          :total="totalPages"
          :perPage="per_page"
          :qnt="reports.length"
        />
      </div>
    </template>
  </div>
</template>

<script>
import { format } from "date-fns";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    PaginationComponent: () => import("@/components/Pagination.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    Loader: () => import("@/components/Loader.vue"),
    NotFound: () => import("@/components/NotFound.vue"),
    DateTimePicker: () => import("@/components/DateTime"),
  },
  data: () => ({
    steps: [
      { name: "Hourly", value: "hour" },
      { name: "Daily", value: "day" },
    ],
    selected: {
      step: "hour",
      start_time: null,
      end_time: null,
      dnis_prefix: null,
      ani: null,
    },
    reports: [],

    vendor: "",
    smsces: [],
    selectedSMSC: null,
    sms_id: "",
    selectedDnis: "",
    selectedAni: "",
    company: "",
    company_uuid: "",
    users: [],
    user: "",
    user_name: "",
    pages: [
      { name: 10, value: 10 },
      { name: 50, value: 50 },
      { name: 100, value: 100 },
    ],
    per_page: 10,
    Page: 0,
    Searched: "",
    ani: null,
    total: 0,
    loading: true,
    showData: Boolean,
    isShow: true,
    smsLogsList: [],
    totalPages: null,
    isClicked: false,
    // vendor_uuid: null,
  }),
  computed: {
    ...mapGetters({
      smsList: "smses/getSmsList",
      smscList: "smsc/getSmscList",
      smscTotalPages: "smsc/getTotalPages",
    }),
    smsLogs() {
      return this.smsList.map((sms) => ({
        text: sms.text,
        ani: sms.sent ? sms.sent.sender : null,
        user_name: sms.user_name,
        company_name: sms.company_name,
        time: this.dateFormat(sms.created_on),
        dnis: sms.sent ? sms.sent.receiver : null,
        dlr: sms.dlr_state,
        sentBy: sms.send_by,
      }));
    },
    startTime() {
      const { day, month, year } = this.getCurrentDateAndTime();

      return new Date(`${month}/${day}/${year} 00:00:00`).getTime();
    },
    endTime() {
      const { day, month, year } = this.getCurrentDateAndTime();

      return new Date(`${month}/${day}/${year} 23:59:59`).getTime();
    },
  },
  watch: {
    Searched: function () {
      this.Page = 0;
      this.GetSmsList();
    },
    company_uuid: function () {
      this.fetchUser();
    },
    filter: function () {
      if (this.filter_val) {
        this.Page = 0;
        this.GetSmsList();
      }
    },
    filter_val: function () {
      this.Page = 0;
      this.GetSmsList();
    },
    per_page(data) {
      this.Page = 0;
      this.search();
    },
    loading(l) {
      this.$emit("loading", l);
    },
  },
  filters: {
    shortText(txt) {
      const length = 40;
      if (txt && txt.length > length) {
        return `${txt.substr(0, length)}...`;
      }

      return txt;
    },
  },
  async created() {
    await this.setDateAndTime();
    await this.fetchUser();
    this.getSmscList();
    this.search();
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  },
  methods: {
    ...mapActions({
      viewSmsC: "smsc/getSmscList",
    }),
    format: function (s, c) {
      return s.replace(/{(\w+)}/g, function (m, p) {
        return c[p];
      });
    },
    base64: function (s) {
      return window.btoa(unescape(encodeURIComponent(s)));
    },
    exportData() {
      this.loading = true;
      const { start_time, end_time, step, dnis_prefix, ani } = this.selected;
      const options = {
        start_time,
        end_time,
        dnis_prefix,
        ani,
        fields: "tx_cost,sent,delivered",
        step,
        per_page: 10,
        page: 0,
      };
      this.$store.dispatch("GetReportList", options).then((res) => {
        const { total } = res;

        this.$store
          .dispatch("GetReportList", { ...options, per_page: total })
          .then((result) => {
            const table_title = ["Date", "Total", "Success", "Cost"];
            const table = document.createElement("table");
            const tr = document.createElement("tr");

            const res = result.data.map(this.transformReport);

            table_title.forEach((title) => {
              const td = document.createElement("td");
              td.innerHTML = title;
              tr.appendChild(td);
            });
            table.appendChild(tr);

            res.forEach((item) => {
              const tr = document.createElement("tr");

              const date = document.createElement("td");
              const total = document.createElement("td");
              const success = document.createElement("td");
              const cost = document.createElement("td");

              date.innerHTML = item.sms_time;
              total.innerHTML = item.sent;
              success.innerHTML = item.delivered;
              cost.innerHTML = item.tx_cost;

              tr.appendChild(date);
              tr.appendChild(total);
              tr.appendChild(success);
              tr.appendChild(cost);

              table.appendChild(tr);
            });

            if (!table || !res.length) {
              this.$snotify.error("Table is empty", {
                timeout: 6000,
              });
              this.loading = false;
              return;
            }

            const ctx = { worksheet: "Worksheet", table: table.innerHTML };
            const uri = "data:application/vnd.ms-excel;base64,";
            const template = `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta 
    http-equiv="content-type" content="text/plain; charset=UTF- 
    8"/></head><body><table>{table}</table></body></html>`;

            const current_date = this.getCurrentDateAndTime();
            const { year, month, day } = current_date;
            const showing_date = `${year}_${month}_${day}`;

            const link = document.createElement("a");
            link.href = uri + this.base64(this.format(template, ctx));
            link.setAttribute("download", `usage_report_${showing_date}.xls`);
            link.click();
            this.loading = false;
          });
      });
    },
    getStartTime(t) {
      const time = new Date(t).getTime();
      this.selected.start_time = time / 1000;
    },
    getEndTime(t) {
      const time = new Date(t).getTime();
      this.selected.end_time = time / 1000;
    },
    getUsernameById(id) {
      const findUser = this.users.find((user) => user.id === id);
      return findUser && findUser.text;
    },
    oneToTwoDigit(num) {
      return String(num).length === 1 ? `0${num}` : num;
    },
    dateFormat(date) {
      const converted_date = new Date(date);
      const year = converted_date.getFullYear().toString().slice(2, 4);
      const _month = (converted_date.getMonth() + 1).toString();
      const month = this.oneToTwoDigit(_month);
      const day = converted_date.getDate();
      const _hours = converted_date.getHours().toString();
      const hours = this.oneToTwoDigit(_hours);
      const _minutes = converted_date.getMinutes().toString();
      const minutes = this.oneToTwoDigit(_minutes);
      const _seconds = converted_date.getSeconds().toString();
      const seconds = this.oneToTwoDigit(_seconds);

      return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
    },
    getCurrentDateAndTime() {
      const date = new Date();
      const day = this.oneToTwoDigit(date.getDate());
      const month = this.oneToTwoDigit(date.getMonth() + 1);
      const year = date.getFullYear();

      return { day, month, year };
    },
    setDateAndTime() {
      this.selected.start_time = this.startTime / 1000;
      this.selected.end_time = this.endTime / 1000;
    },
    transformData(elem) {
      return {
        time: format(elem.sms_time * 1000, "YYYY:MM:DD HH:mm:ss"),
        dnis: elem.dnis,
        ani: elem.ani,
        company_name: elem.company_name,
        user_name: elem.user_name,
        dlr: elem.delivered,
        text: elem.sms_content,
      };
    },
    GetSmsList(order = "desc", sort = "sms_time") {
      this.loading = true;
      this.$store
        .dispatch("GetSmsLogListIncoming", {
          start_time: this.start_time,
          end_time: this.end_time,
          per_page: this.per_page,
          page: this.Page,
          dnis: this.selectedDnis ? `${this.selectedDnis}*` : "",
          ani: this.selectedAni ? `${this.selectedAni}*` : "",
          user_id: this.user || "",
          company_name: this.company || "",
          vendor_id: this.selectedSMSC || "",
          order,
          sort,
        })
        .then((res) => {
          this.loading = false;
          if (!res.data.length) {
            this.$swal({
              title: "No data found",
              text: "",
              type: "warning",
              showCancelButton: false,
              confirmButtonText: "Ok",
              cancelButtonText: "No",
            });
          }
          this.smsLogsList = res.data.map(this.transformData);
        });
    },
    selectDateAndTime(e) {
      this.start_time = new Date(e[0]).getTime() / 1000;
      this.end_time = new Date(e[1]).getTime() / 1000;
      this.Page = 0;
    },
    showText(e, text) {
      e.target.children[0].innerHTML = text;
    },
    getSMSCList() {
      this.$store.dispatch("GetVendorList", {}).then((res) => {
        const { total } = res;

        this.$store
          .dispatch("GetVendorList", { per_page: total })
          .then((res) => {
            this.vendors = res.items.map(this.transformVendor);
          });
      });
    },
    search() {
      this.loading = true;
      const {
        start_time,
        end_time,
        // vendor_uuid,
        step,
        // company,
        dnis_prefix,
        ani,
      } = this.selected;
      this.$store
        .dispatch("GetReportList", {
          start_time,
          end_time,
          // vendor_id: vendor_uuid,
          // company_name: company,
          dnis_prefix,
          ani,
          fields: "tx_cost,sent,delivered",
          step,
          per_page: this.per_page || 10,
          page: this.Page || 0,
        })
        .then((res) => {
          this.loading = false;
          if (!res.data.length) {
            this.totalPages = 0;
            this.reports = [];
            return;
          }
          this.totalPages = res.total / this.per_page;
          this.reports = res.data.map(this.transformReport);
        });
    },
    fetchUser() {
      this.loading = true;
      this.$store
        .dispatch("GetUsers", { per_page: 1000, companyId: this.company_uuid })
        .then((res) => {
          this.loading = false;
          if (this.company_uuid) {
            this.users = [];
          }
          const _res = res.items
            .map((item) => {
              return {
                val: item.user_id,
                text: item.full_name && item.full_name.trim(),
                id: item.user_id,
              };
            })
            .filter((item) => item.text);
          this.users = [...this.users, ..._res];
        });
    },
    changePage(page) {
      this.Page = page;
      this.search();
    },
    async getSmscList(total, order_dir = "desc", order_by = "created_on") {
      this.loading = true;
      await this.viewSmsC({
        page: this.Page,
        perPage: this.smscTotalPages ? this.smscTotalPages : 10,
        order_by: order_by,
        order_dir: order_dir,
      });
      this.loading = false;
    },
    transformReport(rep) {
      return {
        ...rep,
        sms_time: format(rep.sms_time * 1000, "YYYY:MM:DD HH:mm:ss"),
      };
    },
    transformVendor(vendor) {
      return {
        name: vendor.vendor_name,
        value: vendor.vendor_name,
      };
    },
  },
};
</script>
<style>
.el-range-input::placeholder {
  color: #444 !important;
}
#smsc-connecion-select select {
  padding-right: 10px;
}
</style>
<style lang="scss" scoped>
.per-page-box {
  display: flex;
  align-items: center;
  margin-top: 20px;

  .header {
    margin-right: 10px;
  }
  .item {
    width: 120px;

    div,
    select {
      width: 120px;
    }
  }
}
.input {
  position: relative;
  display: block;
  height: 40px;
  width: 100%;

  input {
    width: 100%;
    height: 100%;
    padding: 0 15px;
    border: 1px solid #edeef3;
    border-radius: 4px;
    background-color: #fff;
    font-family: Helvetica Neue;
    font-size: 16px;
    // line-height: 25px;
  }
}
.search-input {
  position: relative;
  height: 40px;
  width: 100%;
  display: flex;
  align-items: center;
  .icon {
    left: 5px;
    position: absolute;
    height: 30px;
    width: 30px;
  }
  input {
    z-index: 2;
    width: 100%;
    height: 100%;
    border: 1px solid #edeef3;
    border-radius: 4px;
    background-color: #fff;
    font-family: Helvetica Neue;
    font-size: 16px;
    line-height: 25px;
    padding-left: 40px;
    background-color: transparent;
  }
}
.equal-field {
  width: 230px !important;
}

.report-container {
  padding: 0 20px;

  .perPage {
    width: 120px;
  }
  .time-th {
    min-width: 180px;
  }
  .sorting {
    cursor: pointer;
  }
  [data-title]:hover:after {
    opacity: 1;
    transition: all 0.1s ease 0.5s;
    visibility: visible;
  }
  [data-title]:after {
    content: attr(data-title);
    background-color: white;
    color: #111;
    font-size: 15px;
    position: absolute;
    padding: 6px 10px;
    top: 3em;
    left: 0%;
    width: auto;
    box-shadow: 1px 1px 3px #343232;
    opacity: 0;
    height: auto;
    border: 1px solid grey;
    z-index: 99999;
    // visibility: hidden;
  }
  [data-title] {
    position: relative;
  }
  .add-navigation {
    // margin-top: 20px;
    margin-bottom: 20px;

    .header {
      margin-bottom: 5px;

      .filter_by {
        font-family: Helvetica Neue;
        font-size: 12px;
        font-weight: 700;
        color: #55616e;
        text-transform: uppercase;
      }
    }
    .btns {
      display: flex;
      flex-direction: row-reverse;
      justify-content: flex-start;
      align-items: center;
      align-content: flex-start;
      padding: 0px 0 16px;
      // width: 250px;

      & > div:first-child {
        margin-left: 15px;
      }
      &.export-button {
        margin-top: 22px;
      }
    }
    .right-wrapper {
      padding: 15px;
      background: #fff;
      width: 100%;

      .header-main {
        margin-bottom: 25px;
        font-size: 16px;
        font-family: "Helvetica Neue";
        font-weight: 500;
      }
      .inputs-box {
        display: flex;
        flex-direction: column-reverse;
        align-items: center;
      }
      .first-line {
        display: flex;
        justify-content: space-between;
        width: 100%;
        margin-top: 15px;

        .search-boxes {
          display: block;
          margin-top: 15px;

          div {
            float: left;
            margin-right: 22px;
            // margin-top: 15px;
          }
          div:first-child {
            margin-left: 0;
          }
          div:last-child {
            margin-right: 0;
          }
        }
      }
      .search-input {
        height: 40px;
        width: 250px;
        margin-right: 10px;
        background-color: #fff;
      }
      .button {
        width: 90px;
        height: 40px;
        margin: 10px 0 0 10px;
      }
      .second-line {
        display: flex;
        width: 100%;
        .selects-wrapper {
          display: flex;
          justify-content: flex-start;
          width: 100% !important;
          margin-bottom: 30px;

          .parent-item {
            display: flex;
            .item {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 100%;
              margin: 0 10px;
              flex-grow: 1;
              div {
                display: inline-block;
              }
            }
          }
          .parent-item:first-child {
            .item:first-child {
              margin-left: 0;
            }
          }
          .parent-item:last-child {
            .item:last-child {
              margin-right: 0;
            }
          }
          .per_page {
            width: 110px;
          }

          .choose-type {
            height: 40px;
            color: #55616e;
            font-weight: 400;
          }
          .inputs {
            display: flex;
            flex-wrap: wrap;

            div {
              margin-right: 10px;
            }
            &:last-child {
              // margin-top: 25px;

              div.el-date-editor {
                width: 485px;
              }
            }
            .equal-field.date-picker {
              margin-right: 20px;
            }
            &.date-inputs div:first-child {
              margin-bottom: 5px;
            }
          }
        }
        .btns {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 30px;
        }
      }
    }
  }
}
.word-break p {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0;
}
.box.equal-field {
  width: 232px !important;
}
.PrimaryButton {
  cursor: pointer;
  height: 40px;
  width: 100%;
  border-radius: 4px;
  background-color: #51a3f3;
  color: #fff;
  outline: none;
  border: none;
  font-family: "Helvetica Neue";
  font-size: 16px;
  font-weight: 500;
  line-height: 30px;
  text-align: center;
  padding: 5px 20px 5px 20px;
}
.secondary-button {
  cursor: pointer;
  height: 100%;
  width: 100%;
  border: 1px solid #bdbfd8;
  border-radius: 4px;
  background-color: #fff;
  color: #55616e;
  font-family: "Helvetica Neue";
  font-size: 16px;
  font-weight: 500;
  line-height: 18px;
  text-align: center;
  padding: 10px 20px 10px 20px;
}
table.Invoice_table {
  width: 100%;

  th {
    text-align: center;

    &.date {
      width: 200px;
    }
  }
}
table thead tr {
  background: linear-gradient(135deg, #51a3f3 0%, #51b5f3 100%);
  th {
    border-bottom-width: 2px;
    color: white;
    padding-left: 10px;
    vertical-align: bottom;
    border-bottom: 2px solid #dee2e6;
    border: 1px solid #dee2e6;
  }
}
table,
tr {
  width: 100%;
  box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -webkit-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -moz-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  background-color: #ffffff;
}

table {
  border-collapse: collapse;
}
.Invoice_table_popup {
  width: 75px;
}
.Invoice_table_header th {
  color: white;
  padding-left: 10px;
  border-bottom-width: 2px;
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
  border: 1px solid #dee2e6;
  padding: 0.75rem;
  text-align: center;
}
.Invoice_table_header th:first-child {
  padding-left: 20px;
  padding-right: 30px;
  width: 14%;
}
tbody th:first-child {
  padding-left: 20px;
  padding-right: 30px;
}
.popup_content {
  display: none;
}
.popup_cta {
  cursor: pointer;
  padding-right: 5px;
}
.Invoice_table_popup {
  text-align: right;
  position: relative;
}
tbody th {
  height: 40px;
  color: #212b36;
  font-weight: normal;
  font-family: "Helvetica Neue";
  font-size: 14px;
  line-height: 20px;
  padding: 15px 20px;
}
tr th.icon {
  width: 80x;
  float: right;
}
tbody {
  th.icon {
    padding: 7px 20px 7px 0;
    .edit {
      margin-right: 20px;
    }
  }
  .img-container {
    padding: 7px 0;
  }
  th.text {
    max-width: 450px;

    span {
      pointer-events: none;
    }
  }
}
.Invoice_price {
  font-family: "Helvetica Neue";
}
.Invoice_table_popup.active .popup_content {
  display: block;
  position: absolute;
  right: 0;
  width: 240px;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0 10px 40px 0 rgba(0, 0, 0, 0.1);
  padding-left: 0;
  list-style-type: none;
  text-align: left;
}
.Invoice_table_popup.active .popup_content a {
  color: #55616e;
  font-size: 16px;
  line-height: 20px;
  text-decoration: none;
  font-family: "Helvetica Neue";
  padding: 10px 15px;
  display: inline-block;
}
.popup_image {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 8px;
}
th.user_active:after {
  content: "";
  height: 10px;
  width: 10px;
  background-color: #24e2b8;
  position: absolute;
  border-radius: 50%;
  left: 12px;
  top: 20px;
}

th.user_active {
  text-align: left;
  position: relative;
  padding-left: 35px;
}
th .svg-grey {
  cursor: pointer;
  fill: #55616e;
}
th .callflow {
  font-size: 12px;
  width: 86px;
  height: 20px;
  padding-top: 0px;
  float: right;
  line-height: 20px;
}
th .number-icon {
  height: 16px;
  width: 16px;
  margin-right: 8px;
}
.primary-input-container {
  .primary-select-wrapper {
    box-sizing: border-box;
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    height: 40px;
    border: 1px solid #edeef3;
    border-radius: 4px;
    background-color: #fff;
    select {
      -webkit-appearance: none;
      -moz-appearance: none;
      -ms-appearance: none;
      appearance: none;
      width: 100%;
      // height: 100%;
      min-height: 38px;
      background: #fff;
      padding-left: 15px;
      font-family: Helvetica Neue;
      font-size: 16px;
      line-height: 25px;
    }
    .icon-down {
      left: 100%;
      margin-left: -35px;
      background: #fff;
    }
  }
  .pimary-input-title {
    color: #000;
    font-family: "Helvetica Neue";
    font-size: 12px;
    font-weight: 300;
    letter-spacing: 0.21px;
    line-height: 15px;
    margin-bottom: 5px;
    text-transform: uppercase;
  }
}
.no-data-found {
  padding: 20px;
  text-align: center;
  font-size: 20px;
  color: #e2e5ea;
  background-color: #fff;
}

@media (max-width: 1310px) {
  table.Invoice_table {
    width: 1200px;
  }
}
@media screen and (max-width: 1345px) {
  .report-container .add-navigation .right-wrapper {
    width: 100%;
    flex-direction: row-reverse;
    align-items: flex-start;
    justify-content: space-between;
    // padding: 0 15%;
  }
  .report-container .add-navigation .right-wrapper .first-line {
    width: fit-content;
    flex-direction: column;
  }
  .report-container .add-navigation .right-wrapper .second-line {
    flex-direction: column;
  }
  .report-container .add-navigation .right-wrapper .first-line .search-boxes {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 26px;
    flex-wrap: wrap;
    // padding-top: 24px;
  }
  .report-container .add-navigation .right-wrapper .first-line .btns {
    width: 230px;
    justify-content: center;
  }
  .report-container
    .add-navigation
    .right-wrapper
    .first-line
    .search-boxes
    div:first-child {
    margin-top: 0;
  }
  .report-container
    .add-navigation
    .right-wrapper
    .first-line
    .search-boxes
    div:last-child {
    margin-right: 0;
  }
  .report-container
    .add-navigation
    .right-wrapper
    .first-line
    .btns
    div:first-child {
    margin: 10px 0 0 0;
  }
  .report-container .add-navigation .right-wrapper .first-line .btns {
    justify-content: space-between;
  }
  .report-container
    .add-navigation
    .right-wrapper
    .second-line
    .selects-wrapper
    .inputs {
    flex-direction: column;
    align-items: center;
  }
  .report-container
    .add-navigation
    .right-wrapper
    .second-line
    .selects-wrapper
    .inputs
    .item:first-child {
    margin-top: 0 !important;
  }
  .report-container
    .add-navigation
    .right-wrapper
    .second-line
    .selects-wrapper
    .inputs
    .item {
    margin: 38px 0 0 !important;
  }
  .report-container
    .add-navigation
    .right-wrapper
    .second-line
    .per-page-box
    .item
    div {
    margin: 0 auto;
  }
}
@media (max-width: 830px) {
  .report-container .add-navigation .right-wrapper {
    display: flex;
    flex-direction: column-reverse;

    .first-line {
      margin-top: 0;
    }
  }
}
.table_div::-webkit-scrollbar {
  // width: 5px;
  width: 8px;
  height: 8px;
  background-color: #f5f5f5;
}

.table_div::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-image: -webkit-gradient(
    linear,
    left bottom,
    left top,
    color-stop(0.44, #51a3f3),
    color-stop(0.72, #51a3f3),
    color-stop(0.86, #51a3f3)
  );
}
.table_div::-webkit-scrollbar {
  // width: 5px;
  width: 8px;
  height: 8px;
  background-color: #f5f5f5;
}

.table_div::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-image: -webkit-gradient(
    linear,
    left bottom,
    left top,
    color-stop(0.44, #51a3f3),
    color-stop(0.72, #51a3f3),
    color-stop(0.86, #51a3f3)
  );
}
  .icon-down {
    pointer-events: none !important;
  }
</style>

